import styled from 'styled-components'

export const UnderlinedLabel = styled.span`
  display: block;
  border-bottom: 1px solid lightgray;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 6px;
`
